export default __webpack_public_path__ + "static/media/easter-egg.510b5b7b.webp";